// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — user-block.styled.classic.js, новая — user-block.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './user-block.styled.classic';
import * as cp from './user-block.styled.cp';

export const Button = isCp ? cp.Button : classic.Button;
export const Content = isCp ? cp.Content : classic.Content;
export const LogoutButton = isCp ? cp.LogoutButton : classic.LogoutButton;
export const Subbutton = isCp ? cp.Subbutton : classic.Subbutton;
export const UserName = isCp ? cp.UserName : classic.UserName;